import { apiClient } from '../http'

export const userService = {
    /**
     * Обновление энергии пользователя (тапинг)
     * Энергия контролируется только сервером
     */
    async updateEnergy(taps, requestId = null) {
        const response = await apiClient.post('/user/energy', {
            taps,
            requestId,
        })
        return response.data
    },

    /**
     * Восстановление энергии пользователя
     */
    async restoreEnergy() {
        const response = await apiClient.post('/user/restore-energy')
        return response.data
    },

    /**
     * Получение баланса и статистики пользователя
     */
    async getBalance() {
        const response = await apiClient.get('/user/balance')
        return response.data
    },

    /**
     * Получение истории транзакций
     */
    async getTransactions(params = {}) {
        const response = await apiClient.get('/user/transactions', { params })
        return response.data
    },

    /**
     * Обновление профиля пользователя
     */
    async updateProfile(profileData) {
        const response = await apiClient.put('/user/profile', profileData)
        return response.data
    },

    /**
     * Получение рейтинга пользователей
     */
    async getLeaderboard(params = {}) {
        const response = await apiClient.get('/user/leaderboard', { params })
        return response.data
    },

    /**
     * История наград (кейсы + адвент)
     */
    async getWithdrawHistory(params = {}) {
        const response = await apiClient.get('/user/withdraw-history', {
            params,
        })
        return response.data
    },

    /**
     * Установка siteId (один раз)
     */
    async setSiteId(siteId) {
        const response = await apiClient.post('/user/site-id', { siteId })
        return response.data
    },

    /**
     * Mines - размещение ставки
     */
    async placeMinesBet(bet) {
        const response = await apiClient.post('/games/mines/bet', { bet })
        return response.data
    },

    /**
     * Mines - забрать выигрыш
     */
    async claimMinesWin(winnings, moves = []) {
        const response = await apiClient.post('/games/mines/win', {
            winnings,
            moves,
        })
        return response.data
    },

    /**
     * Battle - размещение ставки
     */
    async placeBattleBet(bet) {
        const response = await apiClient.post('/games/battle/bet', { bet })
        return response.data
    },

    /**
     * Battle - обработка результата битвы
     * Результат определяется только сервером
     */
    async processBattleResult(bet) {
        const response = await apiClient.post('/games/battle/result', { bet })
        return response.data
    },

    /**
     * Получить статус адвент календаря
     */
    async getAdventStatus() {
        const response = await apiClient.get('/advent/status')
        return response.data
    },

    /**
     * Получить приз за день
     */
    async claimAdventReward(day) {
        const response = await apiClient.post('/advent/claim', { day })
        return response.data
    },

    /**
     * Отметить промокод кейса как просмотренный
     */
    async markCaseViewed(caseId) {
        const response = await apiClient.post(`/user/case/${caseId}/view`)
        return response.data
    },
}
